/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KioskConfigListDto } from '../../models/kiosk-config-list-dto';

export interface KioskConfigControllerFindAllV1$Params {
}

export function kioskConfigControllerFindAllV1(http: HttpClient, rootUrl: string, params?: KioskConfigControllerFindAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<KioskConfigListDto>> {
  const rb = new RequestBuilder(rootUrl, kioskConfigControllerFindAllV1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<KioskConfigListDto>;
    })
  );
}

kioskConfigControllerFindAllV1.PATH = '/api/v1/kiosk-config';
